/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceResourceItem extends models.ServiceResourceDetails {
    getFixupPrototypeFunction() { return ServiceResourceItem.fixupPrototype; }

    static newInstance(model: Partial<ServiceResourceItem>): ServiceResourceItem {
        let obj = Object.assign(new ServiceResourceItem(), model);
        ServiceResourceItem.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceResourceItem>): ServiceResourceItem {
        if (!model) return null;
        return ServiceResourceItem.newInstance(<ServiceResourceItem> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceResourceItem) {
        if (!obj) return;

        models.ServiceResourceItem.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceResourceItem): boolean {
        if (models.ServiceResourceDetails.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceResourceItem.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Inventory record ID of the resource
     */
    sys_id: string;

    /**
     * Extended resource information from cloud provider
     */
    extended_summary_details: any;

    /**
     * Inventory metadata for the resource
     */
    meta_data: any;

}
